import { useTheme } from '@emotion/react'
import { Add, DeleteOutlineRounded, Description, Edit, RemoveRedEyeOutlined, Search } from '@mui/icons-material'
import { Autocomplete, Box, Button, capitalize, Grid, Tooltip, Typography, useMediaQuery } from '@mui/material'
// import { FetchAllStartupFeedbacks } from 'api/profile'
import { FetchAllRounds } from 'api/round'
import Cookies from 'js-cookie'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import { handleDateValues, hasPermission, typeOptions } from 'utils/index'
import DeleteConfirmationDialog from 'ui-components/popups/ConfirmationPopup'
// import placeHolderImage from "assets/no_data_images/no_data_rounds.svg"
import { Primary } from 'ui-components/Buttons';import CustomInputField from 'ui-components/CustomInputField'
import { DeleteUserDataByID, FetchAllVersionsData, FetchVersionDataByID } from 'api/admin_settings'
import toast from 'react-hot-toast'
import toast_message from "utils/toast_message.json"
import { useToast } from 'context/ToastContext'


const Users = ({ refetchListing, searchStatus, setSearchStatus, reset, search, setSearch, setReset, queryParams, setQueryParams, }) => {
  const theme = useTheme();
  const { addToast } = useToast();
  let [investor_id, setStartupID] = React.useState(Cookies.get("X-ADMIN-ID") || null);
  const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate()
  const columns = [
    { Header: 'Version', accessor: 'version', minWidth: 150, align: 'start', fixed: true },
    { Header: 'App Type', accessor: 'app_type', minWidth: 150, align: 'center' },
    { Header: 'Created By', accessor: 'created_by', minWidth: 150, align: 'center' },
    { Header: 'Created Date', accessor: 'created_date', minWidth: 150, align: 'center' },
    { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' },
  ];

  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [sort, setSort] = React.useState(-1);
  // const [search, setSearch] = React.useState(-1);
  const [appType, setAppType] = React.useState({ label: "All", value: "all" });
  const { data: versionsData, isLoading: isLoadingVersions, refetch: refetchVersionsData } = FetchAllVersionsData({ investor_id, limit, page, searchText: search, enabled: hasPermission("settings", "manage_users", userPermissions), app_type: appType?.value })
  const {
    mutateAsync: deleteUserDataAsync,
    isLoading: isDeletingUserData,
    status: deleteUserDataStatus,
    error: deleteUserDataError,
    data: deleteUserDataResponse
  } = DeleteUserDataByID();

  const formattedVersionsData = React.useMemo(() => {
    const dataArray = versionsData?.data || [];
    return !isLoadingVersions ? dataArray?.map(version => {
      return ({
        ...version,
        // name: user?.user_details?.first_name + " " + user?.user_details?.last_name,
        // email: user.user_details?.email,
        // user_role_type: capitalize(user?.user_role_type)
      })
    }) : []
  }, [versionsData, isLoadingVersions])

  const [currentRow, setCurrentRow] = React.useState(null);
  const [showDeletePopup, setShowDeletePopup] = React.useState(false);

  const handleOpenDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }

  const handleDeleteUser = () => {
    // console.log(currentRow?._id,"ddd")
    deleteUserDataAsync({ user_id: currentRow?._id }, {
      onSuccess: () => {
        refetchVersionsData();
        handleCloseDeletePopup();
        addToast(toast_message?.users?.delete, "success")
      },
      onError: () => {
      }
    })
  }
  React.useEffect(() => {
    refetchVersionsData();
  }, [reset, appType]);

  const RowActions = ({ row }) => {
    const currentLocation = window.location;
    // console.log(row?.original,"row")
    return (!row?.original?.is_owner ? <div style={{ display: "flex", marginLeft: 'auto' }}>
      <Tooltip title="View">
        <Button sx={{ minWidth: "1rem" }} onClick={() => {
          Cookies.set("settings_version_id", row?.original?._id);
          // console.log(row?.original?._id, "row?.original?._id")
          // if (currentLocation.pathname?.includes("/admin_settings")) {
          //   navigate("/release_notes/view_version")
          // }
          // else {
            navigate("/admin_settings/release_notes/view_version")
          // }
        }}>
          <RemoveRedEyeOutlined
            sx={{ color: theme.palette.customColors.indigo700 }}

          />
        </Button>
      </Tooltip>
      {/* <Tooltip title="Delete">
        <Button
          sx={{ minWidth: "1rem" }}
          onClick={() => { setCurrentRow(row?.original); handleOpenDeletePopup() }}
        >
          <DeleteOutlineRounded
            sx={{ color: theme.palette.customColors.indigo700 }} />
        </Button>
      </Tooltip> */}
    </div> : "")
  }

  return (
    <>
      <DeleteConfirmationDialog open={showDeletePopup} handleClose={handleCloseDeletePopup} handleSubmission={handleDeleteUser} heading={"Delete User"} ActionText={"Confirm"} subheading={"Are you sure you want to delete this user?"} />
      <Grid container xs={12} pt={1.1} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
        {isLoadingVersions ?

          <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            <Box className='skeleton' minHeight={"70dvh"} sx={{ borderRadius: "8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

            </Box>
          </Grid>
          :
          <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={'hidden'} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
            <Grid container padding={"0.5rem"} sx={{
              border: `1px solid ${theme.palette.customColors.b50} !important`,
              borderRadius: '8px 8px 0px 0px',
              background: theme?.palette.customColors.whiteBG,
            }}>
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3} style={{ display: 'flex', height: 'min-content', alignItems: 'center', gap: "0.5rem" }}>
                {/* <CustomInputField
                  autoComplete="off"
                  sx={{
                    marginBottom: 0,
                    "& > .MuiFilledInput-root": {
                      borderColor: `${theme.palette.customColors.b50} !important`,
                      borderRadius: '8px'
                    }
                  }}
                  fullWidth
                  value={search}
                  name={`search_${Math.random().toString(36).substring(7)}`}  // Set a random name attribute
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      // alert(e.target.value);
                      refetchVersionsData()
                      if (search) {
                        setSearchStatus(true)
                      }
                      setPage(1);
                    }
                  }}
                  onChange={(event) => {
                    setSearch(event.target.value);
                    Cookies.set("search_admin_settings", event.target.value);
                    setSearchStatus(false)
                  }}
                  size="small"
                  startAdornment={<>
                    <Search sx={{ padding: "0rem 0rem 0rem 0.5rem" }} />
                  </>}
                  placeholder={'Search by name'}
                /> */}
                <Autocomplete
                  disablePortal
                  options={[
                    { label: "All", value: "all" },
                    ...typeOptions
                    // { label: "Investor", value: "investor" },
                    // { label: "Startup", value: "startup" },
                    // { label: "Main Website", value: "main_website" },
                  ]}
                  disableClearable
                  fullWidth
                  // getOptionLabel={(option) => appType?.value === option?.value ? `App Type: ${option?.label}` : option?.label}
                  // value={queryParams?.stage}
                  value={appType}
                  autoHighlight
                  onChange={(e, newValue) => { setAppType(newValue); setSearchStatus(false) }}
                  // onChange={(e, newValue) => { setQueryParams({ ...queryParams, stage: newValue?.label }); setSearchStatus(false) }}
                  renderInput={(params) => <CustomInputField variant={"outlined"} placeholder={"Select App Type"} {...params} sx={{ marginBottom: 0 }} className="filter-autocomplete" />}
                />


              </Grid>
              <Grid item width="25%" style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', marginLeft: "auto" }}>
                <Primary
                  onClick={() => {
                    Cookies.remove("settings_version_id");
                    navigate("/admin_settings/release_notes/add_version");
                  }}
                  sx={{
                    // bgcolor: theme.palette.customColors.indigo600,
                    // border: `1px solid ${theme.palette.customColors.indigo600} `,
                    padding: '10px 16px',
                    fontWeight: 600,
                    minWidth: isSmallScreen ? "0" : '64px',
                    '& > .MuiButton-icon.MuiButton-startIcon': {
                      marginRight: isSmallScreen ? 0 : '8px',
                      marginLeft: isSmallScreen ? 0 : '-4px'
                    }
                  }}
                  startIcon={<Add fontSize='1.25rem' />}
                >
                  {!isSmallScreen ? "Add Release Note" : "Add"}
                </Primary>
              </Grid>
            </Grid>

            <Grid id="users-settings-table">
              <AsyncTableListing
                actions={() => <Primary
                  onClick={() => {
                    Cookies.remove("settings_version_id");
                    navigate("/admin_settings/release_notes/add_version");
                  }}
                  sx={{
                    bgcolor: theme.palette.customColors.indigo600,
                    border: `1px solid ${theme.palette.customColors.indigo600} `,
                    padding: '10px 16px',
                    fontWeight: 600,
                    minWidth: isSmallScreen ? "0" : '64px',
                    '& > .MuiButton-icon.MuiButton-startIcon': {
                      marginRight: isSmallScreen ? 0 : '8px',
                      marginLeft: isSmallScreen ? 0 : '-4px'
                    }
                  }}
                  startIcon={<Add fontSize='1.25rem' />}
                >
                  {!isSmallScreen ? "Add Release Note" : "Add"}
                </Primary>}
                // isLoading={isLoadingFeedbacks}
                columns={columns}
                data={formattedVersionsData}
                page={page}
                setPage={setPage}
                limit={limit}
                setLimit={setLimit}
                count={10}
                RowActions={RowActions}
                // tabValue={value}
                pagination={true}
                sx={{
                  borderRadius: '0px 0px 8px 8px',
                  border: `1px solid ${theme.palette.customColors.b50}`,
                  bgcolor: "white"
                }}
              />
            </Grid>
          </Box>
        }

      </Grid>
    </>
  )
}

export default Users
